// import React, { useState } from "react";
// import UpcomingLockersComponent from "./UpcomingLockersComponent";
// import MyLockesComponent from "./MyLockesComponent";
// import UserLockersHistoryComponent from "./UserLockersHistoryComponent";

// export default function UserLockers({ lockersData = [] }) {
//   const [activeTab, setActiveTab] = useState("upcoming");

//   // Process all transactions from all bookings to create upcoming lockers
//   const processUpcomingLockers = () => {
//     const upcomingLockersList = [];
    
//     lockersData.forEach((booking) => {
//       // Check if booking has transactions array
//       if (booking.transactions && booking.transactions.length > 0) {
//         // Create a separate locker item for each transaction
//         booking.transactions.forEach((transaction) => {
//           // Only include if status is reserved
//           if (transaction.status === "reserved" && transaction.payment_status ==="completed") {
//             const formatDateTime = (dateString) => {
//               if (!dateString) return "";
//               const date = new Date(dateString);
//               return date.toLocaleString('en-US', {
//                 year: 'numeric',
//                 month: '2-digit',
//                 day: '2-digit',
//                 hour: '2-digit',
//                 minute: '2-digit',
//                 hour12: false
//               }).replace(',', ' at');
//             };

//             upcomingLockersList.push({
//               id: transaction.id || transaction.ref_id,
//               name: transaction.assignment_name || booking.assignment?.name || "Locker Booking",
//               lockerNumber: transaction.door_no || "Not Assigned",
//               size: transaction.door_size || "Standard",
//               checkIn: formatDateTime(transaction.reserve_start || booking.reserve_start),
//               checkOut: formatDateTime(transaction.reserve_end || booking.reserve_end),
//               bookingRef: booking.ref_id,
//               transactionRef: transaction.ref_id,
//               paymentStatus: transaction.payment_status,
//               status: transaction.status,
//               doorId: transaction.door,
//               currency:transaction.currency,
//               ref_id:transaction.ref_id
//             });
//           }
//         });
//       }
//     });
    
//     return upcomingLockersList;
//   };

//   // Process all transactions to create my lockers (active/reserved)
//   const processMyLockers = () => {
//     const myLockersList = [];
    
//     lockersData.forEach((booking) => {
//       if (booking.transactions && booking.transactions.length > 0) {
//         booking.transactions.forEach((transaction) => {
//           if (transaction.status === "reserved") {
//             const formatDateTime = (dateString) => {
//               if (!dateString) return "";
//               const date = new Date(dateString);
//               return date.toLocaleString('en-US', {
//                 year: 'numeric',
//                 month: '2-digit',
//                 day: '2-digit',
//                 hour: '2-digit',
//                 minute: '2-digit',
//                 hour12: false
//               }).replace(',', ' at');
//             };

//             myLockersList.push({
//               id: transaction.id || transaction.ref_id,
//               name: transaction.assignment_name || booking.assignment?.name || "Locker Booking",
//               size: transaction.door_size || "Standard",
//               checkIn: formatDateTime(transaction.reserve_start || booking.reserve_start),
//               checkOut: formatDateTime(transaction.reserve_end || booking.reserve_end),
//               accessCount: 1, // Each transaction is one locker
//               total: parseFloat(transaction.amount) || parseFloat(booking.amount) || 0,
//               lockerNumber: transaction.door_no,
//               status: transaction.status,
//               paymentStatus: transaction.payment_status,
//               doorId: transaction.door
//             });
//           }
//         });
//       }
//     });
    
//     return myLockersList;
//   };

//   // Process all transactions to create history (completed/expired/cancelled)
//   const processHistoryLockers = () => {
//     const historyLockersList = [];
    
//     lockersData.forEach((booking) => {
//       if (booking.transactions && booking.transactions.length > 0) {
//         booking.transactions.forEach((transaction) => {
//           // Include if status is completed, expired, or cancelled
//           if (transaction.status === "completed" || transaction.status === "expired") {
//             const formatDate = (dateString) => {
//               if (!dateString) return "";
//               const date = new Date(dateString);
//               return date.toLocaleDateString('en-US', {
//                 year: 'numeric',
//                 month: '2-digit',
//                 day: '2-digit'
//               });
//             };

//             historyLockersList.push({
//               id: transaction.id || transaction.ref_id,
//               name: transaction.assignment_name || booking.assignment?.name || "Locker Booking",
//               size: transaction.door_size || "Standard",
//               fromDate: formatDate(transaction.reserve_start || booking.reserve_start),
//               toDate: formatDate(transaction.reserve_end || booking.reserve_end),
//               total: parseFloat(transaction.amount) || parseFloat(booking.amount) || 0,
//               status: transaction.status,
//               lockerNumber: transaction.door_no,
//               doorId: transaction.door
//             });
//           }
//         });
//       }
//     });
    
//     return historyLockersList;
//   };

//   // Use processed data if available, otherwise use fallback data
//   const upcomingLockers = lockersData.length > 0 ? processUpcomingLockers() : [
//     {
//       id: 1,
//       name: "no data",
//       lockerNumber: "no data",
//       size: "no data",
//       checkIn: "no data",
//       checkOut: "no data",
//       tokens: 'no data',
//     }
//   ];

//   const myLockers = lockersData.length > 0 ? processMyLockers() : [
//     {
//       id: 1,
//       name: "no data",
//       size: "no data",
//       checkIn: "no data",
//       checkOut: "no data",
//       accessCount: 'no data',
//       total: 'no data',
//     },
//   ];

//   const historyLockers = lockersData.length > 0 ? processHistoryLockers() : [
//     {
//       id: 1,
//       name: "Penn Station Luggage Hub",
//       size: "Small",
//       fromDate: "2026-02-15",
//       toDate: "2026-02-15",
//       total: 12,
//     }
//   ];

//   return (
//     <div className="user-locker-component">
//       {/* Tabs */}
//             <div className="tabs">
//               <div
//                 className={`tab ${activeTab === "upcoming" ? "active" : ""}`}
//                 onClick={() => setActiveTab("upcoming")}
//               >
//                 Upcoming ({upcomingLockers.length})
//               </div>

//               <div
//                 className={`tab ${activeTab === "my" ? "active" : ""}`}
//                 onClick={() => setActiveTab("my")}
//               >
//                 My Lockers ({myLockers.length})
//               </div>

//               <div
//                 className={`tab ${activeTab === "history" ? "active" : ""}`}
//                 onClick={() => setActiveTab("history")}
//               >
//                 History ({historyLockers.length})
//               </div>
//             </div>

//             {/* Content */}
//             <div className="tab-content">
//               {activeTab === "upcoming" &&
//                 upcomingLockers.map((locker) => (
//                   <UpcomingLockersComponent key={locker.id} locker={locker} />
//                 ))}

//               {activeTab === "my" && (
//                 <MyLockesComponent lockers={myLockers} />
//               )}

//               {activeTab === "history" &&
//                 historyLockers.map((locker) => (
//                   <UserLockersHistoryComponent
//                     key={locker.id}
//                     locker={locker}
//                   />
//                 ))}
//             </div>
//     </div>
//   );
// }

// =================================
// import React, { useEffect, useState } from "react";
// import UpcomingLockersComponent from "./UpcomingLockersComponent";
// import MyLockesComponent from "./MyLockesComponent";
// import UserLockersHistoryComponent from "./UserLockersHistoryComponent";
// import { getAssignedLockerList, getBulkAdvanceBookingAssignLockers } from "../api/api";

// const transformLockerData = (apiData) => {
//   if (!apiData || !apiData.data || !Array.isArray(apiData.data)) {
//     console.error("Invalid API structure:", apiData);
//     return [];
//   }

//   return apiData.data
//     .filter(
//       locker =>
//         locker.status === "reserved" &&
//         locker.payment_status === "completed"
//     )
//     .map(locker => ({
//       amount: locker.amount,
//       assignment: locker.assignment,
//       currency: locker.currency,
//       locker_bank_name: locker.locker_bank_name,
//       order_id: locker.order_id,
//       payment_id: locker.payment_id,
//       payment_status: locker.payment_status,
//       ref_id: locker.ref_id,
//       reserve_end: locker.reserve_end,
//       reserve_start: locker.reserve_start,
//       status: locker.status,
//       transactions: locker.transactions || [],
//       user: locker.user
//     }));
// };

// export default function UserLockers() {
//   const [activeTab, setActiveTab] = useState("upcoming");
//   const[lockersData,  setLockerData] = useState([])
//   const[activeLockers, setActiveLockers] = useState([]);
//   const[historyLockers, setHistoryLockers] = useState([]);

// useEffect(() => {
//   fetchLockerData();
// }, [activeTab]);

// const fetchLockerData = async () => {
//   //setLoadingMessage("Fetching locker details...");

//   try {
//     let response;

//     switch (activeTab) {
//       case "upcoming":
//         response = await getBulkAdvanceBookingAssignLockers();
//         if (response) {
//             const structuredData = transformLockerData(response?.data);
//             setLockerData(structuredData);
//       }
//         break;

//       case "my":
//         response = await getAssignedLockerList(assignmentId = "23232wew", searchText="werwer", pageNumber="32342");
//         if (response) {
//             const structuredData = transformLockerData(response?.data);
//             setLockerData(structuredData);
//       }
//         break;

//       case "history":
//         response = await getAssignedLockerList(assignmentId = "23232wew", searchText="werwer", pageNumber="32342");
//         break;

//       default:
//         break;
//     }

//     // 👉 setLockersData(response.data);
//   } catch (error) {
//     console.error(error);
//   }
// };
//   // Process all transactions from all bookings to create upcoming lockers
//   const processUpcomingLockers = () => {
//     const upcomingLockersList = [];
    
//     lockersData.forEach((booking) => {
//       // Check if booking has transactions array
//       if (booking.transactions && booking.transactions.length > 0) {
//         // Create a separate locker item for each transaction
//         booking.transactions.forEach((transaction) => {
//           // Only include if status is reserved
//           if (transaction.status === "reserved" && transaction.payment_status ==="completed") {
//             const formatDateTime = (dateString) => {
//               if (!dateString) return "";
//               const date = new Date(dateString);
//               return date.toLocaleString('en-US', {
//                 year: 'numeric',
//                 month: '2-digit',
//                 day: '2-digit',
//                 hour: '2-digit',
//                 minute: '2-digit',
//                 hour12: false
//               }).replace(',', ' at');
//             };

//             upcomingLockersList.push({
//               id: transaction.id || transaction.ref_id,
//               name: transaction.assignment_name || booking.assignment?.name || "Locker Booking",
//               lockerNumber: transaction.door_no || "Not Assigned",
//               size: transaction.door_size || "Standard",
//               checkIn: formatDateTime(transaction.reserve_start || booking.reserve_start),
//               checkOut: formatDateTime(transaction.reserve_end || booking.reserve_end),
//               bookingRef: booking.ref_id,
//               transactionRef: transaction.ref_id,
//               paymentStatus: transaction.payment_status,
//               status: transaction.status,
//               doorId: transaction.door,
//               currency:transaction.currency,
//               ref_id:transaction.ref_id
//             });
//           }
//         });
//       }
//     });
    
//     return upcomingLockersList;
//   };

//   // Process all transactions to create my lockers (active/reserved)
//   const processMyLockers = () => {
//     const myLockersList = [];
    
//     activeLockers.forEach((booking) => {
//       if (booking.transactions && booking.transactions.length > 0) {
//         booking.transactions.forEach((transaction) => {
//           if (transaction.status === "reserved") {
//             const formatDateTime = (dateString) => {
//               if (!dateString) return "";
//               const date = new Date(dateString);
//               return date.toLocaleString('en-US', {
//                 year: 'numeric',
//                 month: '2-digit',
//                 day: '2-digit',
//                 hour: '2-digit',
//                 minute: '2-digit',
//                 hour12: false
//               }).replace(',', ' at');
//             };

//             myLockersList.push({
//               id: transaction.id || transaction.ref_id,
//               name: transaction.assignment_name || booking.assignment?.name || "Locker Booking",
//               size: transaction.door_size || "Standard",
//               checkIn: formatDateTime(transaction.reserve_start || booking.reserve_start),
//               checkOut: formatDateTime(transaction.reserve_end || booking.reserve_end),
//               accessCount: 1, // Each transaction is one locker
//               total: parseFloat(transaction.amount) || parseFloat(booking.amount) || 0,
//               lockerNumber: transaction.door_no,
//               status: transaction.status,
//               paymentStatus: transaction.payment_status,
//               doorId: transaction.door
//             });
//           }
//         });
//       }
//     });
    
//     return myLockersList;
//   };

//   // Process all transactions to create history (completed/expired/cancelled)
//   const processHistoryLockers = () => {
//     const historyLockersList = [];
    
//     historyLockers.forEach((booking) => {
//       if (booking.transactions && booking.transactions.length > 0) {
//         booking.transactions.forEach((transaction) => {
//           // Include if status is completed, expired, or cancelled
//           if (transaction.status === "completed" || transaction.status === "expired") {
//             const formatDate = (dateString) => {
//               if (!dateString) return "";
//               const date = new Date(dateString);
//               return date.toLocaleDateString('en-US', {
//                 year: 'numeric',
//                 month: '2-digit',
//                 day: '2-digit'
//               });
//             };

//             historyLockersList.push({
//               id: transaction.id || transaction.ref_id,
//               name: transaction.assignment_name || booking.assignment?.name || "Locker Booking",
//               size: transaction.door_size || "Standard",
//               fromDate: formatDate(transaction.reserve_start || booking.reserve_start),
//               toDate: formatDate(transaction.reserve_end || booking.reserve_end),
//               total: parseFloat(transaction.amount) || parseFloat(booking.amount) || 0,
//               status: transaction.status,
//               lockerNumber: transaction.door_no,
//               doorId: transaction.door
//             });
//           }
//         });
//       }
//     });
    
//     return historyLockersList;
//   };

//   // Use processed data if available, otherwise use fallback data
//   const upcomingLockers = lockersData.length > 0 ? processUpcomingLockers() : [
//     {
//       id: 1,
//       name: "no data",
//       lockerNumber: "no data",
//       size: "no data",
//       checkIn: "no data",
//       checkOut: "no data",
//       tokens: 'no data',
//     }
//   ];

//   const myLockers = activeLockers.length > 0 ? processMyLockers() : [
//     {
//       id: 1,
//       name: "no data",
//       size: "no data",
//       checkIn: "no data",
//       checkOut: "no data",
//       accessCount: 'no data',
//       total: 'no data',
//     },
//   ];

//   const historyLocker = historyLockers.length > 0 ? processHistoryLockers() : [
//     {
//       id: 1,
//       name: "Penn Station Luggage Hub",
//       size: "Small",
//       fromDate: "2026-02-15",
//       toDate: "2026-02-15",
//       total: 12,
//     }
//   ];

//   return (
//     <div className="user-locker-component">
//       {/* Tabs */}
//             <div className="tabs">
//               <div
//                 className={`tab ${activeTab === "upcoming" ? "active" : ""}`}
//                 onClick={() => setActiveTab("upcoming")}
//               >
//                 Upcoming ({upcomingLockers.length})
//               </div>

//               <div
//                 className={`tab ${activeTab === "my" ? "active" : ""}`}
//                 onClick={() => setActiveTab("my")}
//               >
//                 My Lockers ({myLockers.length})
//               </div>

//               <div
//                 className={`tab ${activeTab === "history" ? "active" : ""}`}
//                 onClick={() => setActiveTab("history")}
//               >
//                 History ({historyLocker.length})
//               </div>
//             </div>

//             {/* Content */}
//             <div className="tab-content">
//               {activeTab === "upcoming" &&
//                 upcomingLockers.map((locker) => (
//                   <UpcomingLockersComponent key={locker.id} locker={locker} />
//                 ))}

//               {activeTab === "my" && (
//                 <MyLockesComponent lockers={myLockers} />
//               )}

//               {activeTab === "history" &&
//                 historyLockers.map((locker) => (
//                   <UserLockersHistoryComponent
//                     key={locker.id}
//                     locker={locker}
//                   />
//                 ))}
//             </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import UpcomingLockersComponent from "./UpcomingLockersComponent";
import MyLockesComponent from "./MyLockesComponent";
import UserLockersHistoryComponent from "./UserLockersHistoryComponent";

import { 
  getBulkAdvanceBookingAssignLockers, 
  getAssignedLockerList 
} from "../api/api"; 
import CircularProgressLoader from "./CircularProgressLoader";

const transformLockerData = (apiData) => {
  if (!apiData || !apiData.data || !Array.isArray(apiData.data)) {
    console.error("Invalid API structure:", apiData);
    return [];
  }

  return apiData.data
    .filter(
      locker =>
        locker.status === "reserved" &&
        locker.payment_status === "completed"
    )
    .map(locker => ({
      amount: locker.amount,
      assignment: locker.assignment,
      currency: locker.currency,
      locker_bank_name: locker.locker_bank_name,
      order_id: locker.order_id,
      payment_id: locker.payment_id,
      payment_status: locker.payment_status,
      ref_id: locker.ref_id,
      reserve_end: locker.reserve_end,
      reserve_start: locker.reserve_start,
      status: locker.status,
      transactions: locker.transactions || [],
      user: locker.user
    }));
};

export default function UserLockers() {
  const [activeTab, setActiveTab] = useState("upcoming");
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  
  // Three separate states for different locker types
  const [upcomingLockersData, setUpcomingLockersData] = useState([]);
  const [activeLockersData, setActiveLockersData] = useState([]);
  const [historyLockersData, setHistoryLockersData] = useState([]);

  useEffect(() => {
    fetchLockerData();
  }, [activeTab]);

  console.log("upcomingLockersData data: ",upcomingLockersData);
  const fetchLockerData = async () => {
    setLoading(true);
    setLoadingMessage("Fetching locker details...");

    try {
      switch (activeTab) {
        case "upcoming":
          await fetchUpcomingLockers();
          break;

        case "my":
          await fetchActiveLockers();
          break;

        case "history":
          await fetchHistoryLockers();
          break;

        default:
          break;
      }
    } catch (error) {
      console.error("Error fetching locker data:", error);
      setLoadingMessage("Failed to fetch data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const fetchUpcomingLockers = async () => {
    try {
      const response = await getBulkAdvanceBookingAssignLockers();
      console.log("response: ",response);
      if (response && response.data?.data) {
        const structuredData = transformLockerData(response.data);
        setUpcomingLockersData(structuredData);
      }
    } catch (error) {
      console.error("Error fetching upcoming lockers:", error);
      setUpcomingLockersData([]);
    }
  };

  const fetchActiveLockers = async () => {
    try {

      const assignmentId = "";
      const searchText = "";
      const pageNumber = 1;
      
      const response = await getAssignedLockerList(assignmentId, searchText, pageNumber);
      if (response && response.data) {
        const structuredData = transformLockerData(response);
        setActiveLockersData(structuredData);
      }
    } catch (error) {
      console.error("Error fetching active lockers:", error);
      setActiveLockersData([]);
    }
  };

  const fetchHistoryLockers = async () => {
    try {
      // Fetch completed/expired lockers
      const assignmentId = ""; 
      const searchText = "";
      const pageNumber = 1;
      
      const response = await getAssignedLockerList(assignmentId, searchText, pageNumber);
      if (response && response.data) {
        // Filter for completed/expired status
        const historyData = response.data.data.filter(
          locker => locker.status === "completed" || locker.status === "expired"
        );
        
        const structuredData = transformLockerData({ data: historyData });
        setHistoryLockersData(structuredData);
      }
    } catch (error) {
      console.error("Error fetching history lockers:", error);
      setHistoryLockersData([]);
    }
  };

  // Process upcoming lockers from transactions
  const processUpcomingLockers = () => {
    const upcomingLockersList = [];
    
    upcomingLockersData.forEach((booking) => {
      if (booking.transactions && booking.transactions.length > 0) {
        booking.transactions.forEach((transaction) => {
          if (transaction.status === "reserved" && transaction.payment_status === "completed") {
            const formatDateTime = (dateString) => {
              if (!dateString) return "";
              const date = new Date(dateString);
              return date.toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
              }).replace(',', ' at');
            };

            upcomingLockersList.push({
              id: transaction.id || transaction.ref_id,
              name: transaction.assignment_name || booking.assignment?.name || "Locker Booking",
              lockerNumber: transaction.door_no || "Not Assigned",
              size: transaction.door_size || "Standard",
              checkIn: formatDateTime(transaction.reserve_start || booking.reserve_start),
              checkOut: formatDateTime(transaction.reserve_end || booking.reserve_end),
              bookingRef: booking.ref_id,
              transactionRef: transaction.ref_id,
              paymentStatus: transaction.payment_status,
              status: transaction.status,
              doorId: transaction.door,
              currency: transaction.currency,
              ref_id: transaction.ref_id
            });
          }
        });
      }
    });
    
    return upcomingLockersList;
  };

  // Process active lockers
  const processActiveLockers = () => {
    const activeLockersList = [];
    
    activeLockersData.forEach((booking) => {
      if (booking.transactions && booking.transactions.length > 0) {
        booking.transactions.forEach((transaction) => {
          if (transaction.status === "reserved") {
            const formatDateTime = (dateString) => {
              if (!dateString) return "";
              const date = new Date(dateString);
              return date.toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
              }).replace(',', ' at');
            };

            activeLockersList.push({
              id: transaction.id || transaction.ref_id,
              name: transaction.assignment_name || booking.assignment?.name || "Locker Booking",
              size: transaction.door_size || "Standard",
              checkIn: formatDateTime(transaction.reserve_start || booking.reserve_start),
              checkOut: formatDateTime(transaction.reserve_end || booking.reserve_end),
              accessCount: 1,
              total: parseFloat(transaction.amount) || parseFloat(booking.amount) || 0,
              lockerNumber: transaction.door_no || "Not Assigned",
              status: transaction.status,
              paymentStatus: transaction.payment_status,
              doorId: transaction.door
            });
          }
        });
      }
    });
    
    return activeLockersList;
  };

  // Process history lockers
  const processHistoryLockers = () => {
    const historyLockersList = [];
    
    historyLockersData.forEach((booking) => {
      if (booking.transactions && booking.transactions.length > 0) {
        booking.transactions.forEach((transaction) => {
          if (transaction.status === "completed" || transaction.status === "expired") {
            const formatDate = (dateString) => {
              if (!dateString) return "";
              const date = new Date(dateString);
              return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              });
            };

            historyLockersList.push({
              id: transaction.id || transaction.ref_id,
              name: transaction.assignment_name || booking.assignment?.name || "Locker Booking",
              size: transaction.door_size || "Standard",
              fromDate: formatDate(transaction.reserve_start || booking.reserve_start),
              toDate: formatDate(transaction.reserve_end || booking.reserve_end),
              total: parseFloat(transaction.amount) || parseFloat(booking.amount) || 0,
              status: transaction.status,
              lockerNumber: transaction.door_no || "Not Assigned",
              doorId: transaction.door
            });
          }
        });
      }
    });
    
    return historyLockersList;
  };

  // Get processed data for each tab
  const upcomingLockers = upcomingLockersData.length > 0 
    ? processUpcomingLockers() 
    : [];

  const activeLockers = activeLockersData.length > 0 
    ? processActiveLockers() 
    : [];

  const historyLockers = historyLockersData.length > 0 
    ? processHistoryLockers() 
    : [];

  return (
    <div className="user-locker-component">
      {/* Tabs */}
      <div className="tabs">
        <div
          className={`tab ${activeTab === "upcoming" ? "active" : ""}`}
          onClick={() => setActiveTab("upcoming")}
        >
          Upcoming ({upcomingLockers.length})
        </div>

        <div
          className={`tab ${activeTab === "my" ? "active" : ""}`}
          onClick={() => setActiveTab("my")}
        >
          My Lockers ({activeLockers.length})
        </div>

        <div
          className={`tab ${activeTab === "history" ? "active" : ""}`}
          onClick={() => setActiveTab("history")}
        >
          History ({historyLockers.length})
        </div>
      </div>

      {/* Content */}
      {loading ? 
          <div className='loade-container'>
            <CircularProgressLoader message={loadingMessage} />
          </div>
          :
          <div className="tab-content">
            {activeTab === "upcoming" && (
              upcomingLockers.length > 0 ? (
                upcomingLockers.map((locker) => (
                  <UpcomingLockersComponent key={locker.id} locker={locker} />
                ))
              ) : (
                <div className="empty-state">No upcoming lockers found</div>
              )
            )}

            {activeTab === "my" && (
              activeLockers.length > 0 ? (
                <MyLockesComponent lockers={activeLockers} />
              ) : (
                <div className="empty-state">No active lockers found</div>
              )
            )}

            {activeTab === "history" && (
              historyLockers.length > 0 ? (
                historyLockers.map((locker) => (
                  <UserLockersHistoryComponent
                    key={locker.id}
                    locker={locker}
                  />
                ))
              ) : (
                <div className="empty-state">No history found</div>
              )
            )}
          </div>
      }
    </div>
  );
}